<template>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
    <!-- Dropdown Option Range dates-->
    <div class="d-flex align-items-center">
      <b-dropdown
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        :text="intervalActive"
        variant="flat-primary"
        size="sm"
        dropleft
        :class="intervalActive === 'Intervalo de fechas' ? 'mr-n2 custom-dropdown' : 'mr-3 custom-dropdown'"
      >
        <b-dropdown-item
          v-for="option in optionsInterval"
          :key="option"
          class="text-capitalize text-center"
          :active="intervalActive === option"
          @click="intervalActive = option"
        >
          {{ option }}
        </b-dropdown-item>
      </b-dropdown>

      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="outline-primary"
        size="sm"
        class="ml-n2"
        v-if="intervalActive !== 'Intervalo de fechas'"
        @click="fetchDataByRange"
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="SearchIcon"
            class="mr-50"
          />
          <span class="align-middle d-none d-sm-inline">Buscar</span>
        </div>
      </b-button>
    </div>

    <!-- Custom Date -->
    <div
      v-if="intervalActive === 'Intervalo de fechas'"
      class="d-flex flex-column flex-md-row align-items-center mt-2 mt-md-0"
    >
      <flat-pickr
        v-model="startDate"
        class="form-control text-center flat-picker bg-transparent border-0 shadow-none mb-2 mb-md-0 mr-md-n3"
        :config="{ enableTime: true, dateFormat: 'd-m-Y h:i K', wrap: true, clickOpens: true }"
        placeholder="Desde"
      />
      <feather-icon
        icon="ArrowRightIcon"
        size="20"
        class="mx-2 d-none d-md-block"
      />
      <flat-pickr
        v-model="endDate"
        class="form-control text-center flat-picker bg-transparent border-0 shadow-none ml-md-n3"
        :config="{ enableTime: true, dateFormat: 'd-m-Y h:i K', clickOpens: true }"
        placeholder="Hasta"
      />
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="outline-primary"
        size="sm"
        class="ml-n2 mt-2 mt-md-0"
        @click="fetchDataByRange"
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="SearchIcon"
            class="mr-50"
          />
          <span class="align-middle d-none d-sm-inline">Buscar</span>
        </div>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    flatPickr,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      intervalActive: 'Últimas mediciones',
      optionsInterval: [
        'Últimas mediciones',
        '1 hora',
        '6 horas',
        '12 horas',
        '24 horas',
        'Intervalo de fechas',
      ],
      startDate: '',
      endDate: '',
    }
  },
  methods: {
    fetchDataByRange() {
      let range = 'custom'
      switch (this.intervalActive) {
        case 'Últimas mediciones':
          range = 'default'
          break
        case '1 hora':
          range = '1H'
          break
        case '6 horas':
          range = '6H'
          break
        case '12 horas':
          range = '12H'
          break
        case '24 horas':
          range = '24H'
          break
        default:
          break
      }
      this.$emit('update', this.startDate, this.endDate, range)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.custom-dropdown {
  position: relative;
  z-index: 1000;
}
</style>